  import React, { useEffect, useState, useRef } from "react";

  import { useLocation, useNavigate } from "react-router-dom";
  import Params from "../../../config/Params";
  import { simplePostCall } from "../../../api/ApiServices";
  import ApiConfig from "../../../api/ApiConfig";
  import { FaBookDead, FaPlus } from "react-icons/fa";
  import { FaBookAtlas, FaBookJournalWhills, FaMinus } from "react-icons/fa6";
  import { toast } from "react-toastify";
  import { MdModeEdit } from "react-icons/md";
  import { RiDeleteBin6Line } from "react-icons/ri";
  import { Bookmark, BookOpen, ExternalLink, Plus } from "react-feather";
  import { BiBookAlt, BiBookmark, BiSolidBookAlt } from "react-icons/bi";
  import FileSaver from "file-saver";
  import ReactTooltip from "react-tooltip";
  import { useTranslation } from "react-i18next";
  import { Modal } from "bootstrap";
  import axios from "axios";
  import { Spinner } from "react-bootstrap";
import { convertMinutesToHours } from "../../../Utility/UtilityFunctions";
import useParams from "../../../config/useParams";

  export default function ViewSyllabusData() {
    const { t } = useTranslation();
    const modalRef = useRef(null);
    const modalRef2 = useRef(null);
    const modalRef3 = useRef(null);
      const [params, setParams] = useParams();
    const [tableDataStore, setTabledataStore] = useState([]);
    const [showCreateFull, setShowCreateFull] = useState(false);
    const [academicYear, setAcademicYear] = useState("");
    const [classId, setClassId] = useState("");
    const [subject, setSubject] = useState("");
    const [editLoading, setEditLoading] = useState(false);
    const [hide, setHide] = useState(false);
    const [hideInside, setHideInside] = useState(false);
    const [activeTopicId, setActiveTopicId] = useState(null);
    const [createLesson, setCreateLesson] = useState("");
    const [duration, setDuration] = useState("");
    const [description, setDescription] = useState("");
    const [expandedLessonId, setExpandedLessonId] = useState(null);
    const [expandedTopicId, setExpandedTopicId] = useState(null);
    const location = useLocation();
    const getData = location.state;
    const navic = useNavigate();
    const [storedata, setstoredata] = useState("");
    const [deleteId, setDeleteId] = useState("");
    const [datastores, setDatastores] = useState([]);
    const [draggedItem, setDraggedItem] = useState(null);
    const [lessonId, setLessonId] = useState("");
    const [topicId, setTopicId] = useState("");
    const [edit, setEdit] = useState(false);
    const [editIds, setEditIds] = useState("");
    const [exportLoading, setExportLoading] = useState(false);
     const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => setIsOpen(!isOpen);
  const closeDropdown = () => setIsOpen(false);

    useEffect(() => {
      SyllabusDataView();
    }, []);

    const SyllabusDataView = () => {
      let RequestBody = JSON.stringify({
        api_key: Params.api_key,
        customer_id: Params.customer_id,
        syllabus_id: getData,
      });
      {
        console.log(getData, "getData");
      }
      simplePostCall(ApiConfig.EDIT_VIEW_DATA, RequestBody)
        .then((data) => {
          console.log(data, "data Sednded");
          if(data.result ) {

          
          if (data.list) {
            // setLoading(false);
            console.log(data.list, "SAMPPLE");
            setTabledataStore(data?.list[0]);
            setAcademicYear(data?.list[0]?.academic_year_id);
            setClassId(data?.list[0]?.class_id);
            setSubject(data?.list[0]?.subject_id);
          } else {
            // setLoading(false);
            console.log("NO DATA in view");
          }
          if (data.data) {
            setDatastores(data.data);
          }
        } else {
          toast.error(data.message || t("No data found"));
        }
        })
        .catch((err) => {
          // setLoading(false);
          toast.error(t("Something went wrong. Please try again later."));
          console.log("api res fail", err);
        });
    };
    //  <---------- LESSON VIEW CREATE ------------>
    const Lessonviews = (e) => {
      console.log(e, "working");
      if (e == "lesson") {
        var RequestBody = JSON.stringify({
          api_key: Params.api_key,
          customer_id: Params.customer_id,
          teacher_id: Params.teacher_id,
          syllabus_id: getData,
          lesson_name: createLesson,
          lesson_duration: duration,
          lesson_description: "",
        });
      } else if (e == "topic") {
        var RequestBody = JSON.stringify({
          api_key: Params.api_key,
          customer_id: Params.customer_id,
          teacher_id: Params.teacher_id,
          lesson_id: lessonId,
          topic_name: createLesson,
          topic_duration: duration,
          topic_description: "",
        });
      } else {
        var RequestBody = JSON.stringify({
          api_key: Params.api_key,
          customer_id: Params.customer_id,
          teacher_id: Params.teacher_id,
          topic_id: topicId,
          sub_topic_name: createLesson,
          sub_topic_duration: duration,
          sub_topic_description: description,
        });
      }
      simplePostCall(ApiConfig.LESSON_PLAN_LIST, RequestBody)
        .then((data) => {
          console.log(data, "messages");
          toast.success(data.message);

          setShowCreateFull(false);
          setCreateLesson("");
          setDuration("");
          setDescription("");
          SyllabusDataView();
          setShowCreateFull(false);
          setHide(false);
        })
        .catch((err) => {
          // setLoading(false);
          toast.error(t("Something went wrong. Please try again later. "));
          console.log("api res fail", err);
        });
    };
    //  <---------- LESSON VIEW CREATE ------------>
    const LessonEdit = (e) => {
      setEditLoading(true);
      console.log(e, "working");
      if (e == "lesson") {
        var RequestBody = JSON.stringify({
          api_key: Params.api_key,
          customer_id: Params.customer_id,
          teacher_id: Params.teacher_id,
          syllabus_id: getData,
          lesson_id: editIds,
          lesson_name: createLesson,
          lesson_duration: duration,
          lesson_description: "",
        });
      } else if (e == "topic") {
        var RequestBody = JSON.stringify({
          api_key: Params.api_key,
          customer_id: Params.customer_id,
          teacher_id: Params.teacher_id,
          topic_id: editIds,
          topic_name: createLesson,
          topic_duration: duration,
          topic_description: "",
        });
      } else {
        var RequestBody = JSON.stringify({
          api_key: Params.api_key,
          customer_id: Params.customer_id,
          teacher_id: Params.teacher_id,
          sub_topic_id: editIds,
          sub_topic_name: createLesson,
          sub_topic_duration: duration,
          sub_topic_description: description,
        });
      }
      simplePostCall(ApiConfig.LESSONS_PLAN_EDIT, RequestBody)
        .then((data) => {
          if(data.result) {

          
          console.log(data, "messages");
          toast.success(data.message );
            setCreateLesson("");
          setDuration("");
          setDescription("");
          setShowCreateFull(false);

          SyllabusDataView();
          setShowCreateFull(false);
          setHide(false);
          setEdit(false);
          } else {
            toast.error(data.message || t("No data found"));
          }
        })
        .catch((err) => {
          // setLoading(false);
              toast.error(t("Something went wrong. Please try again later. "));
          console.log("api res fail", err);
        }).finally(()=>{
          setEditLoading(false);
        })
    };
    function deleteData() {
      let newRequestBody = JSON.stringify({
        api_key: Params.api_key,
        customer_id: Params.customer_id,
        syllabus_id: storedata,
      });
      simplePostCall(ApiConfig.SYLLABUS_DELETE_DATA, newRequestBody)
        .then((data) => {
          // setState({ ...state, subject: data.list[0].id });
          toast.success(data.message);
          navic("/NewSyllabus");
          // SyllabusListTable();
        })
        .catch((error) => {
          console.log("api response", error);
        });
    }
    const [deleteLoading, setDeleteLoading] = useState(false);
    function deleteLesson(e) {
      setDeleteLoading(true);
      if (e == "lesson") {
        var RequestBody = JSON.stringify({
          api_key: Params.api_key,
          customer_id: Params.customer_id,
          teacher_id: Params.teacher_id,
          lesson_id: deleteId,
        });
      } else if (e == "topic") {
        var RequestBody = JSON.stringify({
          api_key: Params.api_key,
          customer_id: Params.customer_id,
          teacher_id: Params.teacher_id,
          topic_id: deleteId,
        });
      } else {
        var RequestBody = JSON.stringify({
          api_key: Params.api_key,
          customer_id: Params.customer_id,
          teacher_id: Params.teacher_id,
          sub_topic_id: deleteId,
        });
      }
      simplePostCall(ApiConfig.LESSON_PLAN_DELETE, RequestBody)
        .then((data) => {
          if (data.result) {
            toast.success(data.message);
            SyllabusDataView();
          
          } else {
            toast.error(data?.message || "Something went wrong");
          }
        })
        .catch((error) => {
          console.log("api response", error);
            toast.error(t("Something went wrong. Please try again later."));
        }).finally(()=>{
          const modalInstance = Modal.getInstance(modalRef.current);
          const modalInstance2 = Modal.getInstance(modalRef2.current);
          const modalInstance3 = Modal.getInstance(modalRef3.current);
            modalInstance?.hide();
            modalInstance2?.hide();
            modalInstance3?.hide();
            setTimeout(() => {
    document.querySelector('.modal-backdrop')?.remove();
  }, 300); // allow hide animation to finish
          setDeleteLoading(false);
        })
    }
    const toggleCreateFull = () => {
      setShowCreateFull(!showCreateFull);
    };
    const toggle = () => {
      setHide(!hide);
    };
    const toggleInside = (topicId) => {
      setHideInside(!hideInside);
      setCreateLesson('');
      setDescription('');
      setDuration('')
      setActiveTopicId((prev) => (prev === topicId ? null : topicId));
    };
    // <------------------------->
    const handleDragStart = (event, index) => {
      setDraggedItem(index);
    };

    const handleDragOver = (event, index) => {
      event.preventDefault(); // Required to allow dropping
    };

    const handleDragEnter = (event, index) => {
      event.preventDefault(); // Required to allow dropping
    };

    const handleDragLeave = (event) => {
      // Reset any styles or effects on leaving the drop target
    };

    const handleDrop = (event, newIndex) => {
      event.preventDefault();

      // Retrieve the index of the dragged item
      const oldIndex = draggedItem;

      // If the dragged item index is the same as the dropped index, return
      if (oldIndex === newIndex) {
        return;
      }

      // Clone the datastores array
      const newDatastores = [...datastores];

      // Remove the dragged item from its old position
      const draggedItemData = newDatastores.splice(oldIndex, 1)[0];

      // Insert the dragged item at the new position
      newDatastores.splice(newIndex, 0, draggedItemData);

      // Update the state with the new order
      setDatastores(newDatastores);
    };
    const handleEdit = (name, duration, description, id, status, topic_id) => {
  
      if (status == "lesson") {
        setCreateLesson(name);
        setDuration(duration);
        setDescription(description);
        setShowCreateFull(true);
        setEditIds(id);
      } else if (status == "topic") {
        setCreateLesson(name);
        setDuration(duration);
        setDescription(description);
        setHide(true);
        setEditIds(id);
      } else {
        setCreateLesson(name);
        setDuration(duration);
        setDescription(description);
        setHideInside(true);
        setActiveTopicId(topic_id);
        setEditIds(id);
      }
    };
    const handleLessoncreate = (item, e) => {
      console.log(e, "workinglessonss", item);
      if (e == "lesson") {
        var RequestBody = JSON.stringify({
          api_key: Params.api_key,
          customer_id: Params.customer_id,
          user_id: Params.teacher_id,
          academic_year: academicYear,
          grad_id: classId,
          subject_id: subject,
          assessment_offline_type: "formative",
          lesson_id: item.lessons_id,
        });
      } else if (e == "topic") {
        var RequestBody = JSON.stringify({
          api_key: Params.api_key,
          customer_id: Params.customer_id,
          user_id: Params.teacher_id,
          academic_year: academicYear,
          grad_id: classId,
          subject_id: subject,
          assessment_offline_type: "formative",
          topic_id: item.topic_id,
        });
      } else {
        var RequestBody = JSON.stringify({
          api_key: Params.api_key,
          customer_id: Params.customer_id,
          user_id: Params.teacher_id,
          academic_year: academicYear,
          grad_id: classId,
          subject_id: subject,
          assessment_offline_type: "formative",
          sub_topic_id: item.sub_topic_id,
        });
      }
      console.log(RequestBody, "RequestBody");

      simplePostCall(ApiConfig.FORMATIVE_CREATE, RequestBody)
        .then((data) => {
          console.log(data, "messages");
          if (data.message == "Offline Assessment created successfully") {
            toast.success(data.message);
            navic("/StudentMarkListEdit", {
              state: {
                offlineId: data.data.assessment_offline_id,
                SemExam: data.data.Exam_name,
                academicYear: {
                  label: data.data.Academic_year_name,
                  value: data.data.academic_year,
                },
                assesmentIds: data.data.assessment_id,
                grade: {
                  value: data.data.grade_id,
                  label: data.data.class_name,
                  // value: assessment.grade_id,
                },

                subject: {
                  label: data.data.subject__name,
                  value: data.data.subject_id,
                },
              },
            });
          } else {
            navic("/StudentMarkListEdit", {
              state: {
                offlineId: data.data.assessment_offline_id,
                SemExam: data.data.Exam_name,
                academicYear: {
                  label: data.data.Academic_year_name,
                  value: data.data.academic_year,
                },
                assesmentIds: data.data.assessment_id,
                grade: {
                  value: data.data.grade_id,
                  label: data.data.class_name,
                  // value: assessment.grade_id,
                },

                subject: {
                  label: data.data.subject__name,
                  value: data.data.subject_id,
                },
              },
            });
          }
        })
        .catch((err) => {
          // setLoading(false);
          console.log("api res fail", err);
        });
    };

    

  const teacherexcel = (exceldata) => {
    setExportLoading(true);

    let requestBody = {
      api_key: Params.api_key,
      customer_id: Params.customer_id,
      syllabus_id: tableDataStore?.syllabus_id,
      format: exceldata,
    };

    axios.post(ApiConfig.SYLLABUS_EXPORT, requestBody, {
      responseType: "blob", // 👈 tells axios to treat it as binary
      headers: {
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      setExportLoading(false);

      // Decide file extension (backend may also send Content-Type or filename in headers)
      let fileExtension = exceldata === "pdf" ? "pdf" : "xlsx";

      // Create a blob from response
      const blob = new Blob([response.data], { type: response.headers["content-type"] });

      // Create a temporary link and trigger download
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `syllabus_export.${fileExtension}`; // 👈 filename
      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(link.href);
    })
    .catch((error) => {
      setExportLoading(false);
      console.error("Error exporting syllabus:", error);
      toast.error("Failed to download file");
    });
  };

 


async function downloadFile(filePath , nodeUrl) {
  if (!filePath) return;

  // const filePath = nodeUrl + filePath ;

  const fileName = filePath?.split("/")?.pop();

  const response = await fetch(nodeUrl + filePath );
  const blob = await response.blob();

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;

  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}


   const exportSyllabus = (format) => {
   setExportLoading(true);
      let newRequestBody = JSON.stringify({
        api_key: params.api_key,
        customer_id: params.customer_id,
         syllabus_id : tableDataStore?.syllabus_id,
        // syllabus_name: tableDataStore?.syllabus_name,
        // class_id: tableDataStore?.class_id,
        // subject_id: tableDataStore?.subject_id,
        // academic_year_id: tableDataStore?.academic_year_id,
        // curriculum_id: tableDataStore?.curriculum_id,
        // format: format,
       

      });
      simplePostCall(ApiConfig.SYLLABUS_EXPORT_NEW, newRequestBody, params)
        .then((data) => {
          // setClassess(data.list);
          console.log(data, "Table data");
          if (data.result) {
            downloadFile(data?.filepath , ApiConfig.NODE_URL_2)
         
          } else {
            // setTableDatas([]);
            // setIsLoading(false);
            // toast.error(data.message);
          }
        })
        .catch((error) => {
          console.log("api response", error);
          toast.error('Something went wrong');
          // setIsLoading(false);
          // setIsLoading(false);
        }).finally(()=>{
          setExportLoading(false)
        })
    };

    return (
      <div className="main-sectionn ">
        <div className="col-md-12">
          <div className="announcementCreatee">
            <label className="edit-head">
              {t("Lessons, Topics & Subtopics")}
            </label>
            <div className="View-Buttons">
              <button
                className="View-Buttons1"
                type="submit"
                data-bs-toggle="modal"
                data-bs-target="#staticBackdrop"
                onClick={() => setstoredata(getData)}
              >
                {t("Delete")}
              </button>
              <button
                className="View-Buttons2"
                type="button"
                onClick={() =>
                  navic("/syllabus-Edit", {
                    state: getData,
                  })
                }
              >
                {t("Update")}
              </button>
             
  {/* timetablebutton */}
  {/* <div className="dropdown">

              <button
                  className="btn timetablebutton dropdown-toggle View-Buttons3"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  // disabled={exportLoading}
              //  onClick={()=>{
              //   console.log('kkkkkkkkkkkkkkkkk')
              //  }}
               
                >
                {exportLoading ? <Spinner size="sm" /> : t("Export")} 
                </button>

                <span class="visually-hidden--">{t("Toggle Dropdown")}</span>

                <ul class="dropdown-menu">
                  <li
                    onClick={() => {
                    exportSyllabus("pdf")
                    }}
                  >
                    <a class="dropdown-item datasize" href="#">
                    {t("Save as PDF")} 
                    </a>
                  </li>
                  <li
                    onClick={() => {
                      exportSyllabus("excel");
                    }}
                  >
                    <a class="dropdown-item datasize" href="#">
                    {t("Export to Excel")}
                    </a>
                  </li>
                </ul>
                </div> */}

                 <div className="View-Buttons" style={{ position: "relative" }}>
      <button
        className="btn timetablebutton View-Buttons3"
        type="button"
        onClick={toggleDropdown}
      >
        {exportLoading ? <Spinner size="sm" /> : t("Export")}
      </button>

      {isOpen && (
        <ul
          className="dropdown-menu"
          style={{
            display: "block",
            position: "absolute",
            top: "100%",
            left: 0,
            zIndex: 1000,
          }}
        >
          <li>
            <button
              className="dropdown-item datasize"
              type="button"
              onClick={() => {
                exportSyllabus("pdf");
                closeDropdown();
              }}
            >
              {t("Save as PDF")}
            </button>
          </li>
          {/* <li>
            <button
              className="dropdown-item datasize"
              type="button"
              onClick={() => {
                exportSyllabus("excel");
                closeDropdown();
              }}
            >
              {t("Export to Excel")}
            </button>
          </li> */}
        </ul>
      )}
    </div>
            </div>
          </div>
        </div>
        <div
          class="modal fade"
          id="staticBackdrop"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabindex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header">
                <h1 class="modal-title fs-5" id="staticBackdropLabel"></h1>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                {t("Are you sure you want to delete this Lesson?")}
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  {t("Close")}
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  data-bs-dismiss="modal"
                  onClick={() => deleteData()}
                >
                  {t("Delete")}
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* taleeb */}
        <div
          className="modal fade"
          id="modalone"
          data-bs-backdrop="static"
          tabIndex="-1"
          data-bs-keyboard="false"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
          ref={modalRef}
        >
          <div class="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title fs-5" id="staticBackdropLabel"></h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                {t("Are you sure you want to delete this Lesson?")}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  {t("Close")}
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  // data-bs-dismiss="modal"
                  onClick={() => deleteLesson("lesson")}
                  disabled={deleteLoading}
                >

                  {deleteLoading ? <Spinner/> :  t("Delete")}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="modaltwo"
          data-bs-backdrop="static"
          tabIndex="-1"
          data-bs-keyboard="false"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
          ref={modalRef2}
        >
          <div class="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title fs-5" id="staticBackdropLabel"></h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                {t("Are you sure you want to delete this Topic?")}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  {t("Close")}
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  // data-bs-dismiss="modal"
                  onClick={() => deleteLesson("topic")}
                  disabled={deleteLoading}
                >
                  {deleteLoading ? <Spinner size="sm"/> : t("Delete")}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal fade"
          id="modalthree"
          data-bs-backdrop="static"
          tabIndex="-1"
          data-bs-keyboard="false"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
          ref={modalRef3}
        >
          <div class="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title fs-5" id="staticBackdropLabel"></h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                {t("Are you sure you want to delete this SubTopic?")}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  {t("Close")}
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  // data-bs-dismiss="modal"
                  onClick={() => deleteLesson()}
                  disabled={deleteLoading}
                >
                  {deleteLoading ? <Spinner size="sm" /> : t("Delete")}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th scope="col">{t("Syllabus Name")}</th>
                <td scope="col">{tableDataStore.syllabus_name}</td>
              </tr>
              <tr>
                <th scope="col">{t("Academic Year Name")}</th>
                <td scope="col">{tableDataStore.academic_year_name}</td>
              </tr>
              <tr>
                <th scope="col">{t("Curriculum Name")}</th>
                <td scope="col">{tableDataStore.curriculum_name}</td>
              </tr>
              <tr>
                <th scope="col">{t("Class Name")}</th>
                <td scope="col">{tableDataStore.class_name}</td>
              </tr>
              <tr>
                <th scope="col">{t("Subject Name")}</th>
                <td scope="col">{tableDataStore.subject_name}</td>
              </tr>
            </thead>
          </table>
        </div>
        {console.log(datastores, "datastores")}

        {showCreateFull && (
          <div className="CreateFull">
            <div className="createLess">
              <label>{t("Lesson")}</label>
              <FaMinus onClick={toggleCreateFull} />
            </div>

            <div>
              <input
                type="text"
                class="form-control"
                placeholder={t("Enter lesson")}
                aria-label="Enter lesson"
                aria-describedby="basic-addon1"
                value={createLesson ? createLesson : ""}
                onChange={(e) => {
                  setCreateLesson(e.target.value);
                }}
              />
            </div>
            <div className="createLess">
              <label>{t("Duration(minutes)")}</label>
            </div>
            {/* {console.log(createLesson)} */}
            <div>
              <input
                type="text"
                class="form-control"
                placeholder={t("Enter Minutes")}
                aria-label="Enter Minutes"
                aria-describedby="basic-addon1"
                value={duration ? duration : ""}
                onChange={(e) => {
                  setDuration(e.target.value);
                }}
              />
            </div>
            {/* {console.log(duration)} */}
          </div>
        )}
        {showCreateFull && (
          <button
            className="add_but"
            onClick={() => (edit ? LessonEdit("lesson") : Lessonviews("lesson"))}
            disabled={editLoading}
          >
            {editLoading ? <Spinner size="sm"/> : t("Update")}
          </button>
        )}
        {/* <---accordium satrt----> */}

        <div class="accordion accordion-flush" id="accordionFlushExample">
          {datastores.map((item, index) => (
            <>
              <div
                class="accordion-item custom-acc"
                draggable={false}
                onDragStart={(event) => handleDragStart(event, index)}
                onDragOver={(event) => handleDragOver(event, index)}
                onDragEnter={(event) => handleDragEnter(event, index)}
                onDragLeave={(event) => handleDragLeave(event)}
                onDrop={(event) => handleDrop(event, index)}
              >
                <h2 class="accordion-header ah-1" id={`flush-heading-${index}`}>
                  <button
                    // class="accordion-button collapsed"
                    // type="button"
                    // data-bs-toggle="collapse"
                    // data-bs-target={`#flush-collapse-${index}`}
                    // aria-expanded="false"
                    // aria-controls={`flush-collapse-${index}`}
                    // onClick={() => setLessonId(item.lessons_id)}


                     className={`accordion-button  custom-collapse ${expandedLessonId === item.lessons_id ? 'open' : ''}`}
  onClick={() => {
    setLessonId(item.lessons_id)
    setExpandedLessonId(prev => prev === item.lessons_id ? null : item.lessons_id)}}
                  >
                    <div className="exp-col-icon">
             <i class={`${expandedLessonId === item.lessons_id  ?  "bi bi-dash-circle" : "bi bi-plus-circle" } `}></i>
             </div>
                    <div className="acc-but1">
                      <div className="acc1">
                        <label className="acc-text">
                          {t("Lesson")}: {item.lessons_name}
                        </label>
                        <label className="acc-text">
                          {t("Duration")}:    {convertMinutesToHours(item.lessons_duration)}
                        </label>
                      </div>
                      <div className="acc-de">
                        <div onClick={(e) => 
                          {  e.stopPropagation();
                            handleLessoncreate(item, "lesson")}}>
                          <ReactTooltip effect="solid" />
                          <FaBookAtlas
                            data-tip="Edit student max list"
                            data-place="top"
                            style={{ width: "16px", height: "16px" }}
                          />
                        </div>
                        <div
                          data-bs-toggle="modal"
                          data-bs-target="#modalone"
                          onClick={(e) => {
                            e.stopPropagation();
                            let lessonId = item.lessons_id;
                            setDeleteId(lessonId);
                            // deleteLesson("lesson");
                          }}
                        >
                          <RiDeleteBin6Line
                            data-tip="Delete"
                            data-place="top"
                            style={{ width: "16px", height: "16px" }}
                          />
                        </div>
                        <div
                          onClick={(e) => {
                            e.stopPropagation();
                            setEdit(true);
                            handleEdit(
                              item.lessons_name,
                              item.lessons_duration,
                              "",
                              item.lessons_id,
                              "lesson"
                            );
                            setHide(false);
                          }}
                        >
                          <MdModeEdit
                            data-tip="Edit"
                            data-place="top"
                            style={{ width: "16px", height: "16px" }}
                          /> 
                        </div>
                      </div>
                    </div>
                  </button>
                </h2>
                <div
                //   id={`flush-collapse-${index}`}
                //   class="accordion-collapse collapse"
                //   aria-labelledby={`flush-heading-${index}`}
                //  data-bs-parent="#accordionFlushExample"

                // className={`accordion-collapse ${expandedLessonId === item.lessons_id ? 'show' : 'collapse'}`}
                 className={`accordion-collapse animated-collapse ${
    expandedLessonId === item.lessons_id ? "open" : ""
  }`}

                >

                  
                  
                  <div class="accordion-body ac-body my-custom-border">
                    {/* 2layer */}
                    <div
                      class="accordion accordion-flush"
                      id={`innerAccordion-${index}`}
                    >
                      {item.topic?.map((items, innerIndex) => (
                        <div class="accordion-item" key={innerIndex}>
                        
                          <div
                            class="accordion-header ah-1 custom-acc"
                            id={`flush-heading-${index}-${innerIndex}`}
                          >
                            <button
                              // class="accordion-button collapsed"
                              // type="button"
                              // data-bs-toggle="collapse"
                              // data-bs-target={`#flush-collapse-${index}-${innerIndex}`}
                              // aria-expanded="false"
                              // aria-controls={`flush-collapse-${index}-${innerIndex}`}
                              // onClick={() => setTopicId(items.topic_id)}

                               className={`accordion-button  custom-collapse ${expandedTopicId === items.topic_id ? 'open' : ''}`}
  onClick={() => {
    setTopicId(items.topic_id)
    setExpandedTopicId(prev => prev === items.topic_id ? null : items.topic_id)}}
                            >

                              {/* taleeb     */}
                              {/* {console.log(item.topic_id, "hiiiii")} */}
                                 <div className="exp-col-icon">
             <i class={`${expandedTopicId === items.topic_id?  "bi bi-dash-circle" : "bi bi-plus-circle" } `}></i>
             </div>
                              <div className="acc-but1">
                                <div className="acc1">
                                  <label className="acc-text">
                                    {t("Topic")}: {items.topic_name}
                                  </label>
                                  <label className="acc-text">
                                    {t("Duration")} : {convertMinutesToHours(items.topic_duration)}
                                  </label>
                                </div>
                                <div className="acc-de">
                                  <div
                                    onClick={() =>
                                      handleLessoncreate(items, "topic")
                                    }
                                  >
                                    <ReactTooltip effect="solid" />
                                    <FaBookAtlas
                                      data-tip="Edit student max list"
                                      data-place="top"
                                      style={{ width: "16px", height: "16px" }}
                                    />
                                  </div>
                                  <div
                                    data-bs-toggle="modal"
                                    data-bs-target="#modaltwo"
                                    onClick={() => {
                                      let topicId = items.topic_id;
                                      setDeleteId(topicId);
                                    }}
                                  >
                                    <RiDeleteBin6Line
                                      data-tip="Delete"
                                      data-place="top"
                                      style={{ width: "16px", height: "16px" }}
                                    />
                                  </div>
                                  <div
                                    onClick={() => {
                                      setEdit(true);
                                      setActiveTopicId(null)
                                      handleEdit(
                                        items.topic_name,
                                        items.topic_duration,
                                        "",
                                        items.topic_id,
                                        "topic"
                                      );
                                      setShowCreateFull(false);
                                    }}
                                  >
                                    <MdModeEdit
                                      data-tip="Edit"
                                      data-place="top"
                                      style={{ width: "16px", height: "16px" }}
                                    />
                                  </div>
                                </div>
                              </div>
                            
                            </button>
                            <div
                              id={`flush-collapse-${index}-${innerIndex}`}
                              // class="accordion-collapse collapse"
                              aria-labelledby={`flush-heading-${index}-${innerIndex}`}
                              data-bs-parent={`#innerAccordion-${index}`}

                                   className={`accordion-collapse animated-collapse ${
    expandedTopicId === items.topic_id ? "open" : ""
  }`}
                            >
                              {/* {console.log(items.subtopic, "item.topic")} */}
                              {items?.subtopic.length < 0
                                ? null
                                : items.subtopic?.map((itemss, innerIndex) => (
                                    <div class="accordion-item" key={innerIndex}>
                                      {/* {console.log(itemss, "lastlist")} */}
                                      <div class="accordion-body ac-body">
                                        <div className="acc-but1">
                                          <div className="acc1">
                                            <label className="acc-text">
                                              {t("Sub Topic")}:{" "}
                                              {itemss.sub_topic_name}
                                            </label>
                                            <label className="acc-text">
                                              {t("Duration")}: {' '}
                                              {convertMinutesToHours(itemss.sub_topic_duration)}
                                            </label>
                                            <label>
                                              {t("Description")}:{" "}
                                              {itemss.sub_topic_description}
                                            </label>
                                          </div>
                                          <div className="acc-de">
                                            <div
                                              onClick={() =>
                                                handleLessoncreate(itemss, "")
                                              } 

                                            >
                                              <ReactTooltip effect="solid" />
                                              <FaBookAtlas
                                                data-tip="Edit student max list"
                                                data-place="top"
                                                style={{
                                                  width: "16px",
                                                  height: "16px",
                                                }}
                                              />
                                            </div>
                                            <div
                                              data-bs-toggle="modal"
                                              data-bs-target="#modalthree"
                                              style={{cursor:'pointer'}}
                                              onClick={() => {
                                                let subTopicId =
                                                  itemss.sub_topic_id;
                                                setDeleteId(subTopicId);
                                                console.log(
                                                  subTopicId,
                                                  "subTopicId"
                                                );
                                                // deleteLesson("lesson");
                                              }}
                                            >
                                              <RiDeleteBin6Line
                                                data-tip="Delete"
                                                data-place="top"
                                                style={{
                                                  width: "16px",
                                                  height: "16px",
                                                }}
                                              />
                                            </div>
                                            <div
                                              onClick={() => {
                                                setEdit(true);
                                                   setHide(false);
                                                // setActiveTopicId(items.topic_id);
                                                handleEdit(
                                                  itemss.sub_topic_name,
                                                  itemss.sub_topic_duration,
                                                  itemss.sub_topic_description,
                                                  itemss.sub_topic_id,
                                                  "subtopic",
                                                  items.topic_id,
                                                );
                                              }}
                                            >
                                              <MdModeEdit
                                                data-tip="Edit"
                                                data-place="top"
                                                style={{
                                                  width: "16px",
                                                  height: "16px",
                                                }}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                              {/* {!hideInside && (
                                <button
                                  className="view_plus"
                                  onClick={toggleInside}
                                >
                                  <inside button/>

                                  <FaPlus />
                                  Add subtiopic button
                                </button>
                              )} */}

                              {activeTopicId !== items.topic_id && (
  <button
    className="view_plus"
    onClick={() => {
      setEdit(false)
   
      toggleInside(items.topic_id)}}
  >
    <FaPlus />
     {/* subtopic */}
  </button>
)}
                            </div>

                            {/* {hideInside && ( */}
                            {activeTopicId === items.topic_id && (
                              <div className="CreateFull" key={items.topic_id}>
                                <div className="createLess">
                                  <label>{t("Sub Topic")}</label>
                                  <FaMinus onClick={toggleInside} /> 
                                </div>

                                <div>
                                  <input
                                    type="text"
                                    class="form-control"
                                    placeholder={t("Enter Sub Topic")}
                                    aria-label="Enter Topic"
                                    aria-describedby="basic-addon1"
                                    value={createLesson ? createLesson : ""} /* taleeb */
                                    onChange={(e) => {
                                      setCreateLesson(e.target.value);
                                    }}
                                  />
                                </div>
                                <div className="createLess">
                                  <label>{t("Duration(minutes)")}</label>
                                </div>
                                {/* {console.log(createLesson)} */}
                                <div>
                                  <input
                                    type="text"
                                    class="form-control"
                                    placeholder={t("Enter Minutes")}
                                    aria-label="Enter Minutes"
                                    aria-describedby="basic-addon1"
                                    value={duration ? duration : ""}
                                    onChange={(e) => {
                                      setDuration(e.target.value);
                                    }}
                                  />
                                </div>
                                <div className="createLess">
                                  <label>{t("Description")}</label>
                                </div>
                                {/* {console.log(createLesson)} */}
                                <div>
                                  <input
                                    type="text"
                                    class="form-control"
                                    placeholder={t("Enter Description")}
                                    aria-label="Enter Minutes"
                                    aria-describedby="basic-addon1"
                                    value={description ? description : ""}
                                    onChange={(e) => {
                                      setDescription(e.target.value);
                                    }}
                                  />
                                </div>
                                {/* {console.log(duration)} */}
                              </div>
                            )}
                            {/* {hideInside && ( */}
                            {activeTopicId === items.topic_id && (
                              <button
                                className="add_but"
                                onClick={() =>
                                  edit
                                    ? LessonEdit("subtopic")
                                    : Lessonviews("subtopic")
                                }
                                disabled={editLoading}
                              >
                                {editLoading ? <Spinner size="sm"/> : edit ? t("Update") :  t("Add")} 
                              </button>
                            )}
                          </div>
                        </div>
                      ))}
                      {!hide && (
                        <button className="view_plus" onClick={toggle}>
                          {/* <inside button/> */}

                          <FaPlus />
                        </button>
                      )}
                    </div>

                    {hide && (
                      <div className="CreateFull">
                        <div className="createLess">
                          <label>{t("Topic")}</label>
                          <FaMinus onClick={toggle} />
                        </div>

                        <div>
                          <input
                            type="text"
                            class="form-control"
                            placeholder={t("Enter Topic")}
                            aria-label="Enter Topic"
                            aria-describedby="basic-addon1"
                            value={createLesson ? createLesson : ""}
                            onChange={(e) => {
                              setCreateLesson(e.target.value);
                            }}
                          />
                        </div>
                        <div className="createLess">
                          <label>{t("Duration(minutes)")}</label>
                        </div>
                        {/* {console.log(createLesson)} */}
                        <div>
                          <input
                            type="text"
                            class="form-control"
                            placeholder={t("Enter Minutes")}
                            aria-label="Enter Minutes"
                            aria-describedby="basic-addon1"
                            value={duration ? duration : ""}
                            onChange={(e) => {
                              setDuration(e.target.value);
                            }}
                          />
                        </div>
                        {/* {console.log(duration)} */}
                      </div>
                    )}
                    {hide && (
                      <button
                        className="add_but"
                        onClick={() =>
                          edit ? LessonEdit("topic") : Lessonviews("topic")
                        }
                        disabled={editLoading}
                      >
                        {editLoading ? <Spinner size="sm"/> :  edit ? t("Update") :  t("Add")}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </>
          ))}
        </div>
        {!showCreateFull && (
          <button className="view_plus" onClick={toggleCreateFull}>
            <FaPlus />
          </button>
        )}
        {/* ))} */}
      </div>
    );
  }
